// React & Redux
import React from 'react';
import StripeCheckout from 'react-stripe-checkout';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { userActions } from '_actions';

import { Button } from 'antd';

class StripeButton extends React.Component {
	onToken = (token) => {
		this.props.submitStripe(token.id);
	}

	render() {
		return (
			<StripeCheckout
				token={this.onToken} // submit callback
				stripeKey={process.env.REACT_APP_STRIPE_API_KEY}
				name="Smoothie Club" // the pop-in header title
				description="Healthy Smoothie Delivery Service" // the pop-in header subtitle
				panelLabel="Authorize Card" // 
				image="https://s3-us-west-2.amazonaws.com/smoothieclub-assets/sc-favicon.svg" // the pop-in header image (default none)
				ComponentClass="div"
				currency="CAD"
				locale="en"
				allowRememberMe // "Remember Me" option (default true)
				// opened={this.onOpened} // called when the checkout popin is opened (no IE6/7)
				// closed={this.onClosed} // called when the checkout popin is closed (no IE6/7)
				// Note: you can change the event to `onTouchTap`, `onClick`, `onTouchStart`
				// useful if you're using React-Tap-Event-Plugin
				triggerEvent="onClick"
			>
				<Button loading={this.props.loading}>
					Connect Payment Card
	            </Button>
			</StripeCheckout>
		);
	}
}

const mapStateToProps = (state) => {
	const { loading, user } = state.users;
	return {
		loading,
		user,
	};
};
const mapDispatchToProps = dispatch =>
	bindActionCreators({
		updateUser: userActions.update,
		submitStripe: userActions.submitStripe,
	}, dispatch);

const connectedStripeButton = connect(mapStateToProps, mapDispatchToProps)(StripeButton);
export { connectedStripeButton as StripeButton };



// WEBPACK FOOTER //
// ./src/_components/StripeButton.jsx